import React, {useRef, useState} from "react";
import moment from "moment";
import {Button, Spinner} from "react-bootstrap";

const ExcelExportButton = ({
                            beveragesLineService,
                            startDate,
                            endDate,
                            selectedProductionLineId
                        }) => {
    const downloadLinkRef = useRef(null);
    const [isExporting, setIsExporting] = useState(false);

    const downloadExcelFile = async () => {
        setIsExporting(true);
        const utcStartDate = moment(startDate).utcOffset(0, true).toISOString();
        const utcEndDate = moment(endDate).utcOffset(0, true).toISOString();

        try {
            const response = await beveragesLineService.getCsvFile(selectedProductionLineId, utcStartDate, utcEndDate);
            const url = window.URL.createObjectURL(response.data);
            downloadLinkRef.current.href = url;
            downloadLinkRef.current.download = `${selectedProductionLineId}_object_details_from_${moment(startDate).format('L')}_to_${moment(endDate).format('L')}.xlsx`;
            downloadLinkRef.current.click();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            console.error('Error during file download:', e);
        } finally {
            setIsExporting(false);
        }
    }

    return <>
        {isExporting && (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            }}>
                <div style={{
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '5px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    <Spinner animation="border" variant="primary" />
                    <div style={{ marginTop: '10px' }}>Exporting to Excel...</div>
                </div>
            </div>
        )}
        <Button variant="primary" className="mr-5" onClick={() => downloadExcelFile()}>
            Export to Excel
        </Button>
        <a ref={downloadLinkRef} style={{display: 'none'}}>Download Link</a>
    </>
}

export default ExcelExportButton
